import { AbstractControl, ValidationErrors } from "@angular/forms";

export class DssValidators {
    static hasUpperCase(control: AbstractControl) : ValidationErrors | null {
        if (!(control.value)) { return null; }
        if ( control.value.toLowerCase() !== control.value ) {
            return null;
        }
        return { hasUpperCase: true };
    }
    static hasLowerCase(control: AbstractControl) : ValidationErrors | null {
        if (!(control.value)) { return null; }
        if ( control.value.toUpperCase() !== control.value ) {
            return null;
        }
        return {hasLowerCase: true };
    }
    static hasDigit(control: AbstractControl) : ValidationErrors | null {
        if (!(control.value)) { return null; }
        if ( /\d/.test(control.value) ) {
            return null;
        }
        return { hasDigit: true };
    }
    static hasNonAlphaNumeric(control: AbstractControl) : ValidationErrors | null {
        if (!(control.value)) { return null; }
        if ( !control.value.match(/^[A-Za-z0-9]+$/) ) {
            return null;
        }
        return { hasNonAlphaNumeric: true };
    }
    static hasNoSpace(control: AbstractControl) : ValidationErrors | null {
        if (!(control.value)) { return null; }
        if((control.value as string).indexOf(' ') < 0){
            return null;
        }
        return {hasNoSpace: true};
    }
}

      
      

    